export const wxLoginConfig = {
  appid: 'wwfafe0e10556c17c4',
  agentid: '1000008',
}

export const fileDomain = 'https://gymoo-project-cdn.oss-cn-shenzhen.aliyuncs.com';
